export default [
    'Garden Style',
    'High-Rise',
    'Low-Rise',
    'Mid-Rise',
    'Townhomes/Single Family Rentals',
];
